import React from "react";

const EyeIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.79584 3.9091C6.86389 3.90179 6.93195 3.89935 7 3.89935C8.2882 3.89935 9.33334 4.92539 9.33334 6.23902C9.33334 7.53072 8.2882 8.5787 7 8.5787C5.68993 8.5787 4.66667 7.53072 4.66667 6.23902C4.66667 6.17078 4.6691 6.10254 4.67639 6.0343C4.90243 6.14397 5.16493 6.23902 5.44445 6.23902C6.30243 6.23902 7 5.53956 7 4.67924C7 4.39897 6.90521 4.13575 6.79584 3.9091ZM11.6813 2.74414C12.8188 3.80186 13.5795 5.04725 13.9392 5.93925C14.0194 6.13179 14.0194 6.34626 13.9392 6.53879C13.5795 7.40886 12.8188 8.65425 11.6813 9.73391C10.5365 10.8014 8.96389 11.6983 7 11.6983C5.03611 11.6983 3.46354 10.8014 2.31924 9.73391C1.18174 8.65425 0.421461 7.40886 0.059819 6.53879C-0.0199397 6.34626 -0.0199397 6.13179 0.059819 5.93925C0.421461 5.04725 1.18174 3.80186 2.31924 2.74414C3.46354 1.67763 5.03611 0.779785 7 0.779785C8.96389 0.779785 10.5365 1.67763 11.6813 2.74414ZM7 2.72951C5.06771 2.72951 3.5 4.30148 3.5 6.23902C3.5 8.17657 5.06771 9.74853 7 9.74853C8.93229 9.74853 10.5 8.17657 10.5 6.23902C10.5 4.30148 8.93229 2.72951 7 2.72951Z"
        fill="#3C4651"
      />
    </svg>
  );
};

export default EyeIcon;
